<template>
  <div>
    <LayoutTelaFiltros
      :titulo="this.$route.meta.titulo"
      :registros="listaProdutos"
      :camposTabela="retornaCamposTabela()"
      :camposMascaraValor="['preco', 'valorbarbeiro']"
      ordenarPor="codigo"
      :totalPaginas="totalDePaginas"
      :isLoading="isLoading"
      @buscarTodos="buscarTodos"
      @buscaFiltro="buscaFiltro"
      @clicouItemTabela="clicouItemTabela"
      @limpar="limpar"
    />

    <fab
      :position="floatButton.position"
      :bg-color="floatButton.bgColor"
      :fixed-tooltip="true"
      :actions="floatButton.fabActions"
      :start-opened="true"
      @cadastroProdutos="cadastroProdutos" />
  </div>
</template>

<script>
import fab from 'vue-fab'
import LayoutTelaFiltros from '@/components/layouts/LayoutTelaFiltros.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'

import ProdutoService from '../../services/produtos.service'

const botaoFlutuante = {
  bgColor: '#003149',
  position: 'bottom-right',
  fabActions: [
    {
      name: 'cadastroProdutos',
      icon: 'person_add',
      tooltip: 'Cadastrar produtos',
    },
  ],
}

export default {
  name: 'Produtos',
  components: {
    LayoutTelaFiltros,
    fab,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      listaProdutos: [],
      totalDePaginas: 0,
      floatButton: botaoFlutuante,
      isLoading: false,
    }
  },
  created() {
    this.buscarTodos()
  },
  methods: {
    async buscarTodos(pagina = 0) {
      this.mostrarLoader()
      try {
        const produtos = await ProdutoService.retornaTodos(pagina)
        this.listaProdutos = produtos.lista
        this.totalDePaginas = produtos.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    async buscaFiltro(filtro, pagina = 0) {
      this.mostrarLoader()
      try {
        const produtos = await ProdutoService.retornaTodosPorFiltro(filtro, pagina)
        this.listaProdutos = produtos.lista
        this.totalDePaginas = produtos.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    clicouItemTabela(item) {
      this.$router.push({
        name: 'rota-produtos-alteracao',
        params: { id: item._id },
      })
    },
    limpar() {
      this.listaProdutos = []
      this.totalPaginas = 0
    },
    retornaCamposTabela() {
      return {
        codigo: {
          label: 'Código',
        },
        nome: {
          label: 'Nome',
        },
        preco: {
          label: 'Preço',
        },
        valorbarbeiro: {
          label: 'Comissão barbeiro',
        },
      }
    },
    cadastroProdutos() {
      this.$router.push({ name: 'rota-produtos-cadastro' })
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}

</script>
